require('./bootstrap');

import Vue from 'vue';
import VueRouter from 'vue-router';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import App from './vue/spa/app.vue';


// Components
import EventList from './vue/spa/EventList.vue';
import EventDetail from './vue/spa/EventDetail.vue';
import EventEnroll from './vue/spa/EventEnroll.vue';
import Transcripts from './vue/spa/Transcripts.vue';
import UserUpdate from './vue/spa/UserUpdate.vue';
import OrgUpdate from './vue/spa/OrgUpdate.vue';
import Policies from './vue/spa/Policies.vue';

import 'leaflet/dist/leaflet.css';


Vue.use( VueSweetalert2 );
Vue.use( VueRouter );

const eventHub = new Vue();
Vue.mixin({
    data: function () {
        return {
            eventHub: eventHub
        }
    }
});

const routes = [
    { path: '/', component: EventList },
    { path: '/event/:event', component: EventDetail },
    { path: '/event/:event/enroll', component: EventEnroll },
    { path: '/user/transcripts', component: Transcripts },
    { path: '/user/update', component: UserUpdate },
    { path: '/user-org/update', component: OrgUpdate },
    { path: '/policies', component: Policies },
];

const router = new VueRouter({
    routes
});

const app = new Vue({
    router,
    render: function(createElement) {
        return createElement(App);
    }
}).$mount('#app');